import type { StoryListItem } from "@chuzi/shared/types";

export type CatalogSortOrder =
  | "newest"
  | "oldest"
  | "most-viewed"
  | "least-viewed";

export const DEFAULT_CATALOG_STORY_LIMIT = 20;

export const CATALOG_SORT_ORDERS: CatalogSortOrder[] = [
  "newest",
  "oldest",
  "most-viewed",
  "least-viewed",
];

export function sortCatalogStories(
  stories: StoryListItem[],
  order: CatalogSortOrder,
): StoryListItem[] {
  const sorted = [...stories];

  switch (order) {
    case "newest":
      return sorted.sort((a, b) => b.created_at.localeCompare(a.created_at));
    case "oldest":
      return sorted.sort((a, b) => a.created_at.localeCompare(b.created_at));
    case "most-viewed":
      return sorted.sort((a, b) => {
        const views = b.watch_starts_count - a.watch_starts_count;
        if (views !== 0) return views;
        return b.created_at.localeCompare(a.created_at);
      });
    case "least-viewed":
      return sorted.sort((a, b) => {
        const views = a.watch_starts_count - b.watch_starts_count;
        if (views !== 0) return views;
        return a.created_at.localeCompare(b.created_at);
      });
  }
}

export function catalogSortLexiconKey(order: CatalogSortOrder): string {
  switch (order) {
    case "newest":
      return "catalog_order_newest";
    case "oldest":
      return "catalog_order_oldest";
    case "most-viewed":
      return "catalog_order_most_viewed";
    case "least-viewed":
      return "catalog_order_least_viewed";
  }
}
